var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Document, Font, Image, Page, StyleSheet, Text, View, } from "@react-pdf/renderer";
import { format as formatDate, parse as parseDate } from "date-fns";
import { ptBR } from "date-fns/locale";
export default function CertidaoNegativaDocument(_a) {
    var _b;
    var data = _a.data;
    var currentDate = new Date();
    var hasPendencies = [
        data.bloqueioBca,
        data.bloqueioCnhApreendida,
        data.bloqueioDireto,
        data.cnhVencida,
    ].some(function (item) { return item === true; });
    var prettifyDate = function (date) {
        return formatDate(parseDate(date, "yyyy-MM-dd", new Date()), "dd/MM/yyyy");
    };
    var documentTypeObject = {
        0: "CARTEIRA DE IDENTIDADE",
        1: "CARTEIRA PROFISSIONAL",
        2: "PASSAPORTE",
        3: "CARTEIRA DE RESERVISTA",
    };
    Font.register({
        family: "Montserrat",
        fonts: [
            {
                src: "https://fonts.gstatic.com/s/montserrat/v26/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCtr6Ew-.ttf",
                fontWeight: 400,
                format: "truetype",
            },
            {
                src: "https://fonts.gstatic.com/s/montserrat/v26/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCuM70w-.ttf",
                fontWeight: 700,
                format: "truetype",
            },
        ],
    });
    var styles = StyleSheet.create({
        body: {
            paddingTop: 35,
            paddingBottom: 65,
            paddingHorizontal: 35,
            fontFamily: "Montserrat",
            fontSize: "3mm",
        },
        header: {
            width: "100%",
            borderBottomWidth: 1,
            borderBottomStyle: "solid",
            borderBottomColor: "#000",
            paddingBottom: 16,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            position: "relative",
        },
        headerText: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            position: "absolute",
            left: "0",
            width: "100%",
            height: "100%",
        },
        headerGovText: {
            fontSize: "4mm",
            fontWeight: 700,
            textAlign: "center",
        },
        headerDetranText: {
            fontSize: "3mm",
            fontWeight: 700,
            textAlign: "center",
            marginTop: 8,
        },
        headerPiauiStateImage: {
            width: "auto",
            height: 70,
        },
        headerDetranPiImage: {
            width: "auto",
            height: 70,
        },
        title: {
            fontSize: "3mm",
            fontWeight: 700,
            marginTop: 16,
            textAlign: "center",
        },
        items: {
            marginTop: 24,
            marginBottom: 24,
            width: "100%",
        },
        row: {
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            alignItems: "baseline",
        },
        itemOneThird: {
            width: "33.3333333333%",
        },
        itemTwoThird: {
            width: "66.6666666667%",
        },
        itemLabel: { fontWeight: 700 },
        topGutter: {
            marginTop: 12,
        },
        spacer: {
            width: "100%",
            height: 48,
        },
        footer: {
            width: "100%",
            borderTopWidth: 1,
            borderTopStyle: "solid",
            borderTopColor: "#000",
            paddingTop: 16,
        },
        footerText: {
            textAlign: "right",
            fontWeight: 700,
            width: "100%",
        },
        footerTextTopGutter: {
            marginTop: 4,
        },
        uppercasedText: {
            textTransform: "uppercase",
        },
    });
    return (_jsx(Document, { children: _jsxs(Page, __assign({ style: styles.body }, { children: [_jsxs(View, __assign({ style: styles.header }, { children: [_jsx(Image, { src: "".concat(process.env.PUBLIC_URL, "/images/estado-piaui.png"), style: styles.headerPiauiStateImage }), _jsxs(View, __assign({ style: styles.headerText }, { children: [_jsx(Text, __assign({ style: styles.headerGovText }, { children: "GOVERNO DO ESTADO DO PIAU\u00CD" })), _jsx(Text, __assign({ style: styles.headerDetranText }, { children: "Departamento Estadual de Tr\u00E2nsito" }))] })), _jsx(Image, { src: "".concat(process.env.PUBLIC_URL, "/images/detran-logo.png"), style: styles.headerPiauiStateImage })] })), _jsx(Text, __assign({ style: styles.title }, { children: "CONSULTA PRONTU\u00C1RIO" })), _jsxs(View, __assign({ style: styles.items }, { children: [_jsxs(View, __assign({ style: styles.row }, { children: [_jsx(View, __assign({ style: styles.itemTwoThird }, { children: _jsxs(Text, { children: [_jsx(Text, __assign({ style: styles.itemLabel }, { children: "NOME COMPLETO: " })), _jsx(Text, { children: data.nome })] }) })), _jsx(View, __assign({ style: styles.itemOneThird }, { children: _jsxs(Text, { children: [_jsx(Text, __assign({ style: styles.itemLabel }, { children: "CERTID\u00C3O: " })), _jsx(Text, { children: "NEGATIVA" })] }) }))] })), _jsxs(View, __assign({ style: __assign(__assign({}, styles.row), styles.topGutter) }, { children: [_jsx(View, __assign({ style: styles.itemOneThird }, { children: _jsxs(Text, { children: [_jsx(Text, __assign({ style: styles.itemLabel }, { children: "SEXO: " })), _jsx(Text, { children: data.sexo })] }) })), _jsx(View, __assign({ style: styles.itemOneThird }, { children: _jsxs(Text, { children: [_jsx(Text, __assign({ style: styles.itemLabel }, { children: "CPF: " })), _jsx(Text, { children: data.cpf })] }) })), _jsx(View, __assign({ style: styles.itemOneThird }, { children: _jsxs(Text, { children: [_jsx(Text, __assign({ style: styles.itemLabel }, { children: "RENACH: " })), _jsx(Text, { children: data.renach })] }) }))] })), _jsxs(View, __assign({ style: __assign(__assign({}, styles.row), styles.topGutter) }, { children: [_jsx(View, __assign({ style: styles.itemOneThird }, { children: _jsxs(Text, { children: [_jsx(Text, __assign({ style: styles.itemLabel }, { children: "CATEGORIA ATUAL: " })), _jsx(Text, { children: data.categoriaAtual })] }) })), _jsx(View, __assign({ style: styles.itemOneThird }, { children: _jsxs(Text, { children: [_jsx(Text, __assign({ style: styles.itemLabel }, { children: "REGISTRO: " })), _jsx(Text, { children: data.registro })] }) })), _jsx(View, __assign({ style: styles.itemOneThird }, { children: _jsxs(Text, { children: [_jsx(Text, __assign({ style: styles.itemLabel }, { children: "N\u00DAMERO DA CNH: " })), _jsx(Text, { children: data.numeroCnh })] }) }))] })), _jsxs(View, __assign({ style: __assign(__assign({}, styles.row), styles.topGutter) }, { children: [_jsx(View, __assign({ style: styles.itemOneThird }, { children: _jsxs(Text, { children: [_jsx(Text, __assign({ style: styles.itemLabel }, { children: "VALIDADE DA CNH: " })), _jsx(Text, { children: prettifyDate(data.dataValidadeCnh) })] }) })), _jsx(View, __assign({ style: styles.itemTwoThird }, { children: _jsxs(Text, { children: [_jsx(Text, __assign({ style: styles.itemLabel }, { children: "PRIMEIRA HABILITA\u00C7\u00C3O: " })), _jsxs(Text, { children: [prettifyDate(data.dataPrimeiraHabilitacao), " -", " ", data.ufEmissao] })] }) }))] })), _jsxs(View, __assign({ style: __assign(__assign({}, styles.row), styles.topGutter) }, { children: [_jsx(View, __assign({ style: styles.itemTwoThird }, { children: _jsxs(Text, { children: [_jsx(Text, __assign({ style: styles.itemLabel }, { children: "DOCUMENTO: " })), _jsxs(Text, { children: [documentTypeObject[data.tipoDocumento], " ", data.numeroDocumento, ", ", data.orgaoExpedidor, "-", data.ufOrgaoExpedidor] })] }) })), _jsx(View, __assign({ style: styles.itemOneThird }, { children: _jsxs(Text, { children: [_jsx(Text, __assign({ style: styles.itemLabel }, { children: "DATA DE NASC.: " })), _jsx(Text, { children: prettifyDate(data.dataNascimento) })] }) }))] })), _jsx(View, __assign({ style: __assign(__assign({}, styles.row), styles.topGutter) }, { children: _jsxs(Text, { children: [_jsx(Text, __assign({ style: styles.itemLabel }, { children: "NOME DO PAI: " })), _jsx(Text, { children: data.nomePai })] }) })), _jsx(View, __assign({ style: __assign(__assign({}, styles.row), styles.topGutter) }, { children: _jsxs(Text, { children: [_jsx(Text, __assign({ style: styles.itemLabel }, { children: "NOME DA M\u00C3E: " })), _jsx(Text, { children: data.nomeMae })] }) })), _jsx(View, __assign({ style: __assign(__assign({}, styles.row), styles.topGutter) }, { children: _jsxs(Text, { children: [_jsx(Text, __assign({ style: styles.itemLabel }, { children: "NACIONALIDADE: " })), _jsx(Text, { children: (_b = data.nacionalidade) === null || _b === void 0 ? void 0 : _b.replace(/_/g, " ") })] }) })), _jsx(View, __assign({ style: __assign(__assign({}, styles.row), styles.topGutter) }, { children: _jsxs(Text, { children: [_jsx(Text, __assign({ style: styles.itemLabel }, { children: "MUNIC\u00CDPIO DE NASCIMENTO: " })), data.nacionalidade !== "BRASILEIRO" ? (_jsx(Text, { children: "-" })) : (_jsx(Text, { children: data.municipioNascimento }))] }) })), _jsx(View, __assign({ style: __assign(__assign({}, styles.row), styles.topGutter) }, { children: _jsxs(Text, { children: [_jsx(Text, __assign({ style: styles.itemLabel }, { children: "MUNIC\u00CDPIO RESIDENCIAL: " })), _jsx(Text, { children: data.municipio })] }) })), _jsxs(View, __assign({ style: __assign(__assign({}, styles.row), styles.topGutter) }, { children: [_jsx(View, __assign({ style: styles.itemTwoThird }, { children: _jsxs(Text, { children: [_jsx(Text, __assign({ style: styles.itemLabel }, { children: "BAIRRO: " })), _jsx(Text, { children: data.bairro })] }) })), _jsx(View, __assign({ style: styles.itemOneThird }, { children: _jsxs(Text, { children: [_jsx(Text, __assign({ style: styles.itemLabel }, { children: "CEP: " })), _jsx(Text, { children: data.cep })] }) }))] })), _jsxs(View, __assign({ style: __assign(__assign({}, styles.row), styles.topGutter) }, { children: [_jsx(View, __assign({ style: styles.itemTwoThird }, { children: _jsxs(Text, { children: [_jsx(Text, __assign({ style: styles.itemLabel }, { children: "LOGRADOURO: " })), _jsx(Text, { children: data.logradouro })] }) })), _jsx(View, __assign({ style: styles.itemOneThird }, { children: _jsxs(Text, { children: [_jsx(Text, __assign({ style: styles.itemLabel }, { children: "N\u00DAMERO: " })), _jsx(Text, { children: data.numeroLogradouro })] }) }))] })), _jsx(View, { style: styles.spacer }), _jsx(View, __assign({ style: __assign(__assign({}, styles.row), styles.topGutter) }, { children: _jsxs(Text, { children: [_jsx(Text, __assign({ style: styles.itemLabel }, { children: "PEND\u00CANCIAS: " })), _jsx(Text, { children: hasPendencies ? "COM PENDÊNCIAS" : "NENHUMA" })] }) })), _jsx(View, __assign({ style: __assign(__assign({}, styles.row), styles.topGutter) }, { children: _jsxs(Text, { children: [_jsx(Text, __assign({ style: styles.itemLabel }, { children: "NADA CONSTA: " })), _jsx(Text, __assign({ style: styles.itemLabel }, { children: "SALVO EM PROCESSAMENTO" }))] }) }))] })), _jsxs(View, __assign({ style: styles.footer }, { children: [_jsx(View, __assign({ style: styles.row }, { children: _jsxs(Text, __assign({ style: __assign(__assign({}, styles.footerText), styles.uppercasedText) }, { children: ["TERESINA,", " ", formatDate(currentDate, "dd 'de' MMMM 'de' yyyy", {
                                        locale: ptBR,
                                    })] })) })), _jsx(View, __assign({ style: styles.row }, { children: _jsx(Text, __assign({ style: __assign(__assign({}, styles.footerText), styles.footerTextTopGutter) }, { children: "Documento v\u00E1lido por 30 dias" })) }))] }))] })) }));
}
